import { render } from "./ThreadDetail.vue?vue&type=template&id=ebf7bcac&scoped=true"
import script from "./ThreadDetail.vue?vue&type=script&lang=ts"
export * from "./ThreadDetail.vue?vue&type=script&lang=ts"

import "./ThreadDetail.vue?vue&type=style&index=0&id=ebf7bcac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ebf7bcac"

export default script